import { useEffect, useState } from 'react';
import { useChat } from './useChat';
import { useRealtimeChat } from './useRealtimeChat';

export const useUnreadMessagesCount = () => {
  const { conversations, setConversations, currentUser, canAccessChat } = useChat();
  const [unreadCount, setUnreadCount] = useState(0);

  useRealtimeChat(
    conversations,
    setConversations,
    null,
    currentUser?.id || null,
    () => {},
    canAccessChat,
  );

  useEffect(() => {
    if (!canAccessChat) {
      setUnreadCount(0);
      return;
    }
    const total = conversations.reduce((sum, conv) => {
      return sum + (conv.unreadCount || 0);
    }, 0);
    setUnreadCount(total);
  }, [canAccessChat, conversations]);

  return unreadCount;
};

